export default __webpack_public_path__ + "static/media/hc-12.8c6feefd.mp4";